import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Icon, Text } from '@components'
import { useLanguage } from '@context'

/**
 * Shown when the active tab has no notifications. Soft, centred, on-brand —
 * never a bare empty list.
 */
export const NotificationsEmptyState = (): React.ReactElement => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const { t } = useLanguage()

  return (
    <View style={styles.container}>
      <View style={styles.iconCircle}>
        <Icon name="bell" size={theme.iconSize.jumbo} color={theme.colors.primary} />
      </View>
      <Text type="subtitleBold" color={theme.colors.black} center style={styles.title}>
        {t('notifications.empty.title')}
      </Text>
      <Text type="bodySmall" color={theme.colors.greyBlue} center>
        {t('notifications.empty.subtitle')}
      </Text>
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: theme.spacing.xxxl * 2,
      paddingHorizontal: theme.spacing.xl,
    },
    iconCircle: {
      width: 88,
      height: 88,
      borderRadius: 44,
      backgroundColor: theme.colors.primary + '12',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: theme.spacing.lg,
    },
    title: {
      marginBottom: theme.spacing.xs,
    },
  })
